const { fountainRegex } = require('./regex')
const wrap = require('word-wrap')

const widths = {
  action: 60,
  dialogue: 34,
  dual_dialogue: 20,
  character: 30,
  parenthetical: 32,
  dual_parenthetical: 20,
  dual_character: 15,
  transition: 48 // TBD, check
}

const structureTypes = {
  title_page: (match, flag, original) => {
    original = original.replace(fountainRegex.title_page, '\n$1').split(fountainRegex.splitter).reverse()
    const xlen = match.length
    const _tokens = []
    for (let x = 0; x < xlen; x++) {
      const parts = original[x].replace(fountainRegex.cleaner, '').split(fountainRegex.title_page)
      parts.shift()
      const parts0 = parts[0] || ''
      parts.shift()
      const parts1 = parts.join(' ')
      _tokens.unshift({ type: parts0.trim().toLowerCase().replace(' ', '_').replace(':', ''), text: parts1.trim() })
    }
    _tokens.push({ type: 'title_page_break', logical_page: 1 })
    return _tokens
  },
  scene_heading: (match) => {
    let text = match[1] || match[2]
    let meta = text.match(fountainRegex.scene_number)
    if (meta) {
      meta = meta[2]
      text = text.replace(fountainRegex.scene_number, '')
    }
    const toWrap = text.replace(new RegExp(`\\S{${widths.action}}`, 'g'), '$& ')
    const wrapped = wrap(toWrap, { width: widths.action, indent: '' })
    const lines = wrapped.split('\n').length + 1
    return [{ type: 'scene_heading', text: text, scene_number: meta || undefined, wrapped, lines, blanks: 1 }]
  },
  centered: (match) => {
    const text = match[0].replace(/>|</g, '').trim()
    const toWrap = text.replace(new RegExp(`\\S{${widths.action}}`, 'g'), '$& ')
    const wrapped = wrap(toWrap, { width: widths.action, indent: '' })
    const lines = wrapped.split('\n').length + 1
    return [{ type: 'centered', text, wrapped, lines, blanks: 1 }]
  },
  transition: (match) => {
    const text = match[1] || match[2]
    const toWrap = text.replace(new RegExp(`\\S{${widths.transition}}`, 'g'), '$& ')
    const wrapped = wrap(toWrap, { width: widths.transition, indent: '' })
    const lines = wrapped.split('\n').length + 1
    return [{ type: 'transition', text, wrapped, lines, blanks: 1 }]
  },
  dual_dialogue: (match) => {
    if (match[1].indexOf('  ') !== match[1].length - 2) {
      let _tokens = []
      _tokens.unshift({ type: 'dual_dialogue_end' })

      _tokens = structureTypes.dialogue(match, 'right').concat(_tokens)
      return _tokens
    }
  },
  dialogue: (match, dual) => {
    const _tokens = []
    // we're iterating from the bottom up, so we need to push these backwards
    _tokens.unshift({ type: 'dialogue_end', blanks: 1 })
    let blockLines = 0

    const parts = match[2].split(/(\(.+\))(?:\n+)/).reverse()
    const xlen = parts.length
    for (let x = 0; x < xlen; x++) {
      const text = parts[x]
      if (text.length > 0) {
        if (fountainRegex.parenthetical.test(text)) {
          const parenWidth = dual ? widths.dual_parenthetical : widths.parenthetical
          const toWrap = text.replace(new RegExp(`\\S{${parenWidth}}`, 'g'), '$& ')
          const wrapped = wrap(toWrap, { width: parenWidth, indent: '' })
          const lines = wrapped.split('\n').length
          blockLines += lines // for dialogue_begin, we need to know the whole block length to determine page breaks
          _tokens.unshift({ type: 'parenthetical', text: text, wrapped, lines, blanks: 0 })
        } else {
          const dialogueWidth = dual ? widths.dual_dialogue : widths.dialogue
          const toWrap = text.replace(new RegExp(`\\S{${dialogueWidth}}`, 'g'), '$& ')
          const wrapped = wrap(toWrap.trim(), { width: dialogueWidth, indent: '' })
          const lines = wrapped.split('\n').length
          blockLines += lines // for dialogue_begin, we need to know the whole block length to determine page breaks
          _tokens.unshift({ type: 'dialogue', text: text.trim(), wrapped, lines, blanks: 0 })
        }
      }
    }

    const text = match[1].replace(/^@/, '').trim()
    const width = dual ? widths.dual_character : widths.character
    const toWrap = text.replace(new RegExp(`\\S{${width}}`, 'g'), '$& ')
    const wrapped = wrap(toWrap, { width, indent: '' })
    const lines = wrapped.split('\n').length
    const blockCount = blockLines + lines + 1
    _tokens.unshift({ type: 'character', text, wrapped, lines, blanks: 0 })
    _tokens.unshift({ type: 'dialogue_begin', dual: dual, raw_lines: blockCount, lines: dual ? 0 : blockCount, blanks: 0 }) // total incl. character and blank below for page break

    if (dual === 'left') {
      _tokens.unshift({ type: 'dual_dialogue_begin', lines: blockCount, blanks: 0 })
    }
    return _tokens
  },
  lyrics: (match) => {
    const text = match[1]
    const toWrap = text.replace(new RegExp(`\\S{${widths.action}}`, 'g'), '$& ')
    const wrapped = wrap(toWrap, { width: widths.action, indent: '' })
    const lines = wrapped.split('\n').length + 1
    return [{ type: 'lyrics', text, wrapped, lines, blanks: 1 }]
  },
  section: (match) => {
    const text = match[2]
    const toWrap = text.replace(new RegExp(`\\S{${widths.action}}`, 'g'), '$& ')
    const wrapped = wrap(toWrap, { width: widths.action, indent: '' })
    const lines = wrapped.split('\n').length + 1
    return [{ type: 'section', text, depth: match[1].length, wrapped, lines, blanks: 1 }]
  },
  synopsis: (match) => {
    const text = match[1]
    const toWrap = text.replace(new RegExp(`\\S{${widths.action}}`, 'g'), '$& ')
    const wrapped = wrap(toWrap, { width: widths.action, indent: '' })
    const lines = wrapped.split('\n').length + 1
    return [{ type: 'synopsis', text, wrapped, lines, blanks: 1 }]
  },
  note: (match) => {
    const text = match[0]
    const toWrap = text.replace(new RegExp(`\\S{${widths.action}}`, 'g'), '$& ')
    const wrapped = wrap(toWrap, { width: widths.action, indent: '' })
    const lines = wrapped.split('\n').length + 1
    return [{ type: 'note', text, wrapped, lines, blanks: 1 }]
  },
  note_inline: (match) => {
    const text = match[0]
    const toWrap = text.replace(new RegExp(`\\S{${widths.action}}`, 'g'), '$& ')
    const wrapped = wrap(toWrap, { width: widths.action, indent: '' })
    return [{ type: 'note', text, wrapped, lines: 0 }] // inline === no lines (?)
  },
  boneyard: (match) => {
    return [{ type: match[0][0] === '/' ? 'boneyard_begin' : 'boneyard_end' }]
  },
  page_break: (match) => {
    return [{ type: 'page_break' }]
  },
  line_break: (match) => {
    return [{ type: 'line_break' }]
  }
}

module.exports = structureTypes
